const DOC_LABELS_EN = {
  // IMS common docs
  'ims-polityka':              'Integrated Management System Policy',
  'ims-kontekst':              'Organisational Context Analysis (IMS)',
  'ims-strony-zainteresowane': 'Interested Parties Register (IMS)',
  'ims-ryzyka-szanse':         'Procedure - Risks and Opportunities (IMS)',
  'ims-cele-programy':         'Procedure - Management Objectives and Programmes (IMS)',
  'ims-kompetencje':           'Procedure - Competence and Training (IMS)',
  'ims-komunikacja':           'Procedure - Communication (IMS)',
  'ims-dokumentacja':          'Procedure - Document and Records Management (IMS)',
  'ims-audyty':                'Procedure - Internal Audits (IMS)',
  'ims-przeglad':              'Procedure - Management Review (IMS)',
  'ims-dzialania-korygujace':  'Procedure - Nonconformities and Corrective Actions (IMS)',

  // ISO 9001
  'polityka-jakosci':          'Quality Policy',
  'proc-niezgodnosci':         'Procedure - Nonconformity Management',
  'proc-audyty':               'Procedure - Internal Audits',
  'proc-przeglad':             'Procedure - Management Review',
  'proc-ryzyko':               'Procedure - Risks and Opportunities',
  'proc-dokumentacja':         'Procedure - Document Management',
  'proc-dzialania-korygujace': 'Procedure - Corrective Actions',
  'analiza-kontekstu':         'Organisational Context Analysis',
  'proc-dostawcy':             'Procedure - Supplier Management',
  'proc-reklamacje':           'Procedure - Customer Complaints',
  'proc-cele-jakosci':         'Procedure - Quality Objectives Management',
  'grc-capa-tracker':          'CAPA Register - Corrective Actions',

  // ISO 14001
  'polityka-srodowiskowa':          'Environmental Policy',
  '14001-analiza-kontekstu':        'Environmental Context Analysis',
  '14001-proc-ryzyko':              'Procedure - Risks and Opportunities (EMS)',
  '14001-rejestr-stron':            'Interested Parties Register (EMS)',
  '14001-cele-programy':            'Procedure - Environmental Objectives and Programmes',
  '14001-proc-dokumentacja':        'Procedure - Document Management (EMS)',
  '14001-proc-audyty':              'Procedure - Internal Audits (EMS)',
  '14001-proc-przeglad':            'Procedure - Management Review (EMS)',
  '14001-proc-dzialania-korygujace':'Procedure - Corrective Actions (EMS)',
  'proc-aspekty':                   'Procedure - Environmental Aspect Identification',
  'proc-zgodnosc-prawna':           'Procedure - Legal Compliance Evaluation',
  'proc-odpady':                    'Procedure - Waste Management',
  'proc-awarie-env':                'Procedure - Environmental Emergency Preparedness',
  'rejestr-aspektow':               'Environmental Aspects Register',

  // ISO 45001
  'polityka-bhp':              'OH&S Policy',
  '45001-analiza-kontekstu':   'Organisational Context Analysis (OHSMS)',
  '45001-rejestr-stron':       'Interested Parties Register (OH&S)',
  '45001-cele-programy':       'Procedure - OH&S Objectives and Programmes',
  '45001-proc-dokumentacja':   'Procedure - Document Management (OH&S)',
  '45001-proc-audyty':         'Procedure - Internal Audits (OH&S)',
  '45001-proc-przeglad':       'Procedure - Management Review (OH&S)',
  '45001-proc-niezgodnosci':   'Procedure - Nonconformities and Corrective Actions',
  '45001-proc-ryzyko':         'Procedure - Risks and Opportunities (OH&S)',
  'proc-zagrozenia':           'Procedure - Hazard Identification and Risk Assessment',
  'proc-soi':                  'Procedure - Personal Protective Equipment (PPE)',
  'proc-szkolenia-bhp':        'Procedure - OH&S Training',
  'proc-konsultacje-bhp':      'Procedure - Worker Consultation and Participation',
  'proc-wypadki':              'Procedure - Accidents and Incidents',

  // ISO 27001
  'polityka-bi':               'Information Security Policy (ISMS)',
  '27001-analiza-kontekstu':   'Organisational Context Analysis (ISMS)',
  '27001-rejestr-stron':       'Interested Parties Register (ISMS)',
  '27001-proc-dokumentacja':   'Procedure - Document Management (ISMS)',
  '27001-proc-audyty':         'Procedure - Internal Audits (ISMS)',
  '27001-proc-przeglad':       'Procedure - Management Review (ISMS)',
  '27001-proc-niezgodnosci':   'Procedure - Nonconformities and Corrective Actions (ISMS)',
  'ocena-ryzyka-bi':           'Procedure - Information Security Risk Management',
  'proc-incydenty-bi':         'Procedure - Information Security Incident Management',
  'proc-dostep':               'Procedure - Access Control',
  'proc-backup':               'Procedure - Backup and Data Recovery',
  '27001-cele-bezpieczenstwa': 'Procedure - Information Security Objectives',
  'grc-risk-control-mapping':  'Register - Risk-to-Control Mapping',
  'grc-asset-criticality':     'Information Asset Register with Criticality Classification',
  'grc-inherent-residual':     'Risk Assessment Sheet - Inherent vs. Residual',
  'grc-vuln-prioritization':   'Vulnerability Prioritisation Matrix',
  'grc-policy-attestation':    'Policy and Procedure Attestation Register',
  'proc-klasyfikacja-info':    'Procedure - Information Classification',
  'ins-zglaszanie-incydentow': 'Instruction - Incident Reporting (Users)',
  'zal-a-zasady-bezp':         'Annex A - Information Security Rules (Employees)',
  'zal-b-zasady-postepowania': 'Annex B - Handling Rules by Classification',
  'zal-c-tabela-klasyfikacji': 'Annex C - Classification Reference Table',
  'nis2-soa-iso27001':         'Statement of Applicability ISO 27001 (SoA)',

  // ISO 22301
  'polityka-bcm':              'Business Continuity Policy',
  '22301-analiza-kontekstu':   'Organisational Context Analysis (BCM)',
  '22301-rejestr-stron':       'Interested Parties Register (BCM)',
  '22301-cele-programy':       'Procedure - Business Continuity Objectives',
  '22301-proc-dokumentacja':   'Procedure - Document Management (BCM)',
  '22301-proc-audyty':         'Procedure - Internal Audits (BCM)',
  '22301-proc-przeglad':       'Procedure - Management Review (BCM)',
  '22301-proc-niezgodnosci':   'Procedure - Nonconformities and Corrective Actions (BCM)',
  'proc-bia':                  'Procedure - Business Impact Analysis (BIA)',
  'proc-ocena-ryzyka-bcm':     'Procedure - Business Continuity Risk Assessment',
  'plan-bcm':                  'Business Continuity Plan (BCP)',
  'proc-reagowanie-bcm':       'Procedure - Incident Response',
  'proc-testy-bcm':            'Procedure - BCM Testing and Exercises',
  'proc-komunikacja-kryz':     'Procedure - Crisis Communication',

  // IATF 16949
  'iatf-polityka':      'Automotive Quality Policy',
  'iatf-apqp':          'Procedure - APQP (Advanced Product Quality Planning)',
  'iatf-ppap':          'Procedure - PPAP (Production Part Approval Process)',
  'iatf-fmea':          'Procedure - FMEA (Failure Mode and Effects Analysis)',
  'iatf-control-plan':  'Procedure - Control Plan',
  'iatf-msa':           'Procedure - MSA (Measurement System Analysis)',
  'iatf-8d':            'Procedure - 8D (Problem Solving)',
  'iatf-proc-ryzyko':   'Procedure - Risk and Opportunity Management (IATF)',
  'iatf-dostawcy':      'Procedure - Supplier Quality Management',
  'iatf-awaryjny':      'Contingency Plan - Production Continuity',
  'iatf-niezgodny':     'Procedure - Nonconforming Product Control',
  'iatf-audyty-wew':    'Procedure - IATF Internal Audits',
  'iatf-gwarancje':     'Procedure - Warranty Management',
  'iatf-identyfikowalnosc': 'Procedure - Traceability',

  // NIS2 / UKSC
  'polityka-bi-nis2':        'Information Security Policy (ISMS / NIS2)',
  'nis2-polityka':           'IT Security Policy (Cybersecurity)',
  'nis2-incydenty':          'Procedure - NIS2 Incident Management',
  'nis2-ryzyko':             'Cybersecurity Risk Register NIS2',
  'nis2-lancuch':            'Procedure - Supply Chain Security',
  'nis2-ciagloss':           'Procedure - Business Continuity NIS2',
  'nis2-raportowanie':       'Procedure - Incident Reporting to CSIRT',
  'nis2-checklista-audit':   'NIS2 Internal Audit Checklist',
  'nis2-gap-analysis':       'NIS2 Gap Analysis Sheet - Assessment Tool',
  'nis2-rejestr-it':         'IT Assets and Software Register',
  'nis2-szkolenia':          'Cybersecurity Training and Awareness Plan',
  'nis2-deklaracja':         'NIS2/UKSC Statement of Applicability',
  'nis2-plan-wdrozenia':     'NIS2 Implementation Plan - Priority Roadmap',
  'grc-compliance-calendar': 'Compliance Schedule - Compliance Calendar',
  'grc-vendor-risk-scoring': 'Critical Vendor Risk Scoring Matrix',
  'grc-threat-landscape':    'Threat Landscape Monitoring Log',
  'grc-incident-class':      'Incident Classification and Escalation Matrix',
  'nis2-proc-podatnosci':    'Vulnerability Management Procedure',
  'nis2-polityka-ryzyko':    'Cybersecurity Risk Management Procedure',

  // VDA 6.3
  'vda-procedura':     'VDA 6.3 Process Audit Procedure',
  'vda-plan':          'VDA 6.3 Audit Plan',
  'vda-checklista-p5': 'P5 Checklist - Supplier Management',
  'vda-checklista-p6': 'P6 Checklist - Process Analysis',
  'vda-raport':        'VDA 6.3 Audit Report',
  'vda-niezgodnosci':  'VDA 6.3 Nonconformity Register',

  // ISO/IEC 42001 AI Governance
  'ai-polityka':                'AI Policy',
  'ai-analiza-kontekstu':       'Organisational Context Analysis (AIMS)',
  'ai-rejestr-stron':           'Interested Parties Register (AIMS)',
  'ai-role-odpowiedzialnosci':  'AI Roles and Responsibilities',
  'ai-zglaszanie-obaw':         'Procedure - Reporting Concerns about AI Systems',
  'ai-zarzadzanie-ryzykiem':    'Procedure - AI Risk Management',
  'ai-cele':                    'Procedure - AI Objectives',
  'ai-proc-dokumentacja':       'Procedure - Document Management (AIMS)',
  'ai-proc-audyty':             'Procedure - Internal Audits (AIMS)',
  'ai-proc-przeglad':           'Procedure - Management Review (AIMS)',
  'ai-proc-niezgodnosci':       'Procedure - Nonconformities and Corrective Actions (AIMS)',
  'ai-rejestr-systemow':        'AI Systems Register',
  'ai-ocena-wplywu':            'Procedure - AI System Impact Assessment',
  'ai-rozwoj-wdrozenie':        'Procedure - AI System Development and Deployment',
  'ai-eksploatacja-monitoring': 'Procedure - AI System Operation and Monitoring',
  'ai-zarzadzanie-danymi':      'Procedure - Data Management for AI Systems',
  'ai-informowanie-stron':      'Procedure - Informing Stakeholders about AI Systems',
  'ai-odpowiedzialne-uzycie':   'Procedure - Responsible Use of AI Systems',
  'ai-dostawcy-strony-trzecie': 'Procedure - Managing AI Suppliers and Third Parties',
  'ai-deklaracja-stosowania':   'Statement of Applicability for AI Controls (SoA)',
};

export const NORM_SUBLABEL_EN = {
  '9001':  'Quality Management',
  '14001': 'Environmental Management',
  '45001': 'Occupational Health & Safety',
  '27001': 'Information Security',
  '22301': 'Business Continuity (BCM)',
  '16949': 'Automotive Quality Management',
  'nis2':  'Cybersecurity (EU Directive)',
  'vda63': 'Process Audit (Automotive)',
  '42001': 'AI Management Systems',
};

export default DOC_LABELS_EN;
